import axios from 'axios';
import { toast } from 'react-toastify';
import {
  COLLECTIONS_LOAD_PHI_AUDIT_BEGIN,
  COLLECTIONS_LOAD_PHI_AUDIT_SUCCESS,
  COLLECTIONS_LOAD_PHI_AUDIT_FAILURE,
  COLLECTIONS_LOAD_PHI_AUDIT_DISMISS_ERROR,
} from './constants';
import { builderSurfaceJsonContentHeader } from '../../../common/utils/restApiHeaderUtils';

export function loadCollectionPHIAudit(args = {}) {
  return (dispatch) => {
    dispatch({
      type: COLLECTIONS_LOAD_PHI_AUDIT_BEGIN,
    });
    const { projectId, version, collectionName } = args;
    const header = builderSurfaceJsonContentHeader(projectId);
    const promise = new Promise((resolve, reject) => {
      const doRequest = axios.get(
        `${process.env.REACT_APP_BUILDER_ENGINE}v${version}/phi-audit/collection/${collectionName}`,
        header,
      );
      doRequest.then(
        (res) => {
          if (res.data && res.data.code === 200) {
            dispatch({
              type: COLLECTIONS_LOAD_PHI_AUDIT_SUCCESS,
              data: res.data,
            });
            resolve(res);
          } else {
            dispatch({
              type: COLLECTIONS_LOAD_PHI_AUDIT_FAILURE,
              data: { error: 'Failed' },
            });
            toast.error(`Failed to load PHI Audit for ${collectionName}`);
            reject('Failed');
          }
        },
        (err) => {
          dispatch({
            type: COLLECTIONS_LOAD_PHI_AUDIT_FAILURE,
            data: { error: err },
          });
          toast.error(`Failed to load PHI Audit for ${collectionName}`);
          reject(err);
        },
      );
    });

    return promise;
  };
}

export function dismissLoadCollectionPHIAuditError() {
  return {
    type: COLLECTIONS_LOAD_PHI_AUDIT_DISMISS_ERROR,
  };
}

export function reducer(state, action) {
  switch (action.type) {
    case COLLECTIONS_LOAD_PHI_AUDIT_BEGIN:
      return {
        ...state,
        loadCollectionPHIAuditPending: true,
        loadCollectionPHIAuditError: null,
      };

    case COLLECTIONS_LOAD_PHI_AUDIT_SUCCESS:
      return {
        ...state,
        loadCollectionPHIAuditPending: false,
        loadCollectionPHIAuditError: null,
      };

    case COLLECTIONS_LOAD_PHI_AUDIT_FAILURE:
      return {
        ...state,
        loadCollectionPHIAuditPending: false,
        loadCollectionPHIAuditError: action.data.error,
      };

    case COLLECTIONS_LOAD_PHI_AUDIT_DISMISS_ERROR:
      return {
        ...state,
        loadCollectionPHIAuditError: null,
      };

    default:
      return state;
  }
}
